import React, { Component } from 'react'
import SearchBar from '../commons/SearchBar/SearchBar.container'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import MapSucursal from './components/Map'
import Slider from '../../components/Slider'
import SliderHomeResponsive from '../../components/Slider/responsive'
import Imis from '../commons/SliderMarketReports/imi'
import News from '../PageHome/components/Noticias'
import Newsletter from '../../components/Newsletter'
import Brokers from '../../components/Brokers'
import { translate } from 'react-translate'
import Services from '../../components/Services'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'


@translate('Sucursal')
class Sucursal extends Component {

  UNSAFE_componentWillMount(){
    window.scrollTo(0, 0)
    this.props.didMount()
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.params.name != this.props.params.name){
      this.props.loadMoreOperationTypes(nextProps.params.name)
      let name = nextProps.params.name
      let office = this.props.offices.find(e=>e.name.replace(/\s/g, '').toLowerCase()==name)
      switch (name) {
        case 'sanisidro' :
          this.props.loadMoreOperationTypes('sanisidro')
          this.props.onSelectOffice(office)
          break
        case 'nordelta' :
          this.props.loadMoreOperationTypes('nordelta')
          this.props.onSelectOffice(office)
          break
        case 'puertos' :
          this.props.loadMoreOperationTypes('puertos')
          this.props.onSelectOffice(office)
          break
        case 'recoleta' :
          this.props.loadMoreOperationTypes('recoleta')
          this.props.onSelectOffice(office)
          break
        case 'palermo' :
          this.props.loadMoreOperationTypes('palermo')
          this.props.onSelectOffice(office)
          break
        case 'pilar' :
          this.props.loadMoreOperationTypes('pilar')
          this.props.onSelectOffice(office)
          break;
        case 'escobar' :
          this.props.loadMoreOperationTypes('escobar')
          this.props.onSelectOffice(office)
          break;
      }
    }
    else {
      if ((!this.props.originOffice || !this.props.originOffice.id) && this.props.offices.length) {
        let name = nextProps.params.name
        let office = this.props.offices.find(e=>e.name.replace(/\s/g, '').toLowerCase()==name)
        this.props.loadMoreOperationTypes(name)
        this.props.onSelectOffice(office)
      }
    }
  }

  render () {
    let param = this.props.params.name
    let relevants = []
    let parsed_services

    const {
      subsidiaries,
      directors,
      brokers,
      imis,
      news,
      centro,
      nordelta,
      sanisidro,
      puertos,
      pilar,
      escobar,
      palermo,
      t,
      services,
      setPhone
    } = this.props

    let subsidiary = selectSubsidiary(param)
    let directorsFilter = selectDirector(subsidiary)
    let brokersFilter = selectBrokers(subsidiary)
    let directorsandbrokers = (directorsFilter || []).concat(brokersFilter || [])

    switch (param) {
      case 'sanisidro' :
        relevants = sanisidro
        parsed_services = services.filter(value => value.name=='viviendas - sanisidro')
        break
      case 'nordelta' :
        relevants = nordelta
        parsed_services = services.filter(value => value.name=='viviendas - nordelta')
        break
      case 'puertos' :
        relevants = puertos
        parsed_services = services.filter(value => value.name=='viviendas - puertos')
        break
      case 'recoleta' :
        relevants = centro
        parsed_services = services.filter(value => value.name=='viviendas - centro')
        break
      case 'pilar' :
        relevants = pilar;
        parsed_services = services.filter(value => value.name=='viviendas - pilar')
        break;
      case 'escobar' :
        relevants = escobar;
        parsed_services = services.filter(value => value.name=='viviendas - escobar')
        break;
      case 'palermo' :
        relevants = centro
        parsed_services = services.filter(value => value.name=='viviendas - palermo')
        break
    }

    function renderStyle (img) {
      var style = {
        backgroundImage: 'url(' + img + ')'
      }
      return style
    }

    function selectDirector (subsidiary) {
      if (!subsidiary) return []
      let id = subsidiary.subsidiary
      if (directors){
        var arrayDirector = directors.filter(function (d) {
          return d.subsidiary === id
        })
        return arrayDirector
      }
    }

    function selectBrokers (subsidiary) {
      if (!subsidiary) return []
      let id = subsidiary.subsidiary
      if (brokers){
        var arrayBrokers = brokers.filter(function (d) {
          return d.subsidiary === id
        })
        return arrayBrokers
      }
    }

    function selectSubsidiary (name) {
      if (subsidiaries){
        var arraySubsidiaries = subsidiaries.find(function (d) {
          var slug = d.name.replace(/\s/g, '').toLowerCase()
          return ((d.is_home === '0') && (slug === name))
        })
        return arraySubsidiaries
      }
    }

    if (!subsidiary)
      return null

    return (
      <div className='container-fluid'>
        <MainBanner
          backgroundURL={subsidiary.image}
          mainTitle={subsidiary.title}
        >
          <SearchBar />
        </MainBanner>
        <Services services={parsed_services}/>
        { (relevants.length > 0) ? (
          <div className='slider-container slider-sector'>
            <div className='text-center title-slide'>{t('Propiedades_Destacadas')}</div>
            <div className='hidden-xs'>
              <Slider properties={relevants}/>
            </div>
            <div className='visible-xs box-slider'>
              <SliderHomeResponsive items={relevants}/>
            </div>
          </div> ) : ''
        }

        <div className='form-container'>
          <ContactForm
            section={subsidiary.title}
            tel={subsidiary.telefono}
            dir={subsidiary.address}
            setPhone={setPhone}
          />
        </div>

        {/* { (directorsandbrokers.length > 0) ? (
          <div className='brokers-container'>
            <Brokers brokers={directorsandbrokers} section={subsidiary.title} />
          </div>
        ) : '' } */}

        <div className='form-newsletter-container'>
          <Newsletter />
        </div>
        {(imis.length > 0) ?
          <div>
            <Imis imis={imis}/>
          </div> : '' }
        {(news.length > 0) ?
          <News news={news} />
        : '' }
        <div className='sector-map'>
          {(subsidiary.mapa && subsidiary.mapa.lat && subsidiary.mapa.lng)?
            (
              <MapSucursal
              lat={subsidiary.mapa.lat}
              lng={subsidiary.mapa.lng}
              img={subsidiary.image}
              address={subsidiary.address}
              name={subsidiary.title}
              code={subsidiary.code}
              tel={subsidiary.telefono}
            />
            ):''}
        </div>
      </div>
    )

  }
}

export default Sucursal



// WEBPACK FOOTER //
// ./src/features/PageBranches/PageBranches.component.js